<template>
  <section class="TheReturnPolicy">
    <h2 class="TheReturnPolicy_Heading">Grove Collaborative Refund Policy</h2>
    <p class="TheReturnPolicy_EffectiveDate">
      Effective Date: February 11, 2022
    </p>

    <PoliciesGrovePronounDisclaimer />

    <p>
      This refund policy is incorporated into and is subject to
      <SkyLink inline to="/terms">the Grove Collaborative Terms of Use</SkyLink
      >. Capitalized terms used in this refund policy but not defined have the
      meaning set forth in
      <SkyLink inline to="/terms">the Grove Collaborative Terms of Use</SkyLink
      >.
    </p>

    <p>
      Grove Collaborative wants you to be happy with your purchase, so our
      return policy makes it easier for you to try our products with confidence.
      If you are not completely satisfied with the quality of a product
      purchased from us through the Service, you may request a refund within 30
      days of purchase by submitting your request to Customer Happiness
      <SkyLink
        inline
        to="https://community.grove.co/hc/en-us/requests/new"
        target="_blank"
        tag="a"
        >here</SkyLink
      >. Once processed, your refund will be in the form of either store credit
      or a refund back to your payment method depending on the reason for your
      refund request. If you request a refund for an incorrect, defective or
      damaged product; we will issue you a refund to the same method of payment
      (e.g., credit card, PayPal, store credit, etc.) used to make your purchase
      following Grove Collaborative’s receipt of the item being returned. If the
      refund request is for other reasons (e.g., the product was not what you
      expected) or if we are unable to issue your refund to the same payment
      method used for the purchase (such as when you cancel or replace your
      credit card), then we may issue the refund as store credit. Please note
      that we will not refund your order if you accidentally purchase an
      incorrect number of products.
    </p>

    <p>All refund requests must include the following information</p>

    <ul class="TheReturnPolicy_BulletPoints">
      <li>Full name of purchaser</li>
      <li>Your email address and the date of delivery</li>
      <li>Name and quantity of the product for which a refund is requested</li>
      <li>Reason for requesting a refund.</li>
    </ul>

    <p>
      We reserve the right to refuse any refund request if you do not make it
      within 30 days of purchase or if we determine, in our sole discretion,
      that the refund request may be a violation of
      <SkyLink inline to="/terms">the Grove Collaborative Terms</SkyLink>.
    </p>

    <p>
      To request a refund, submit your request to Community Happiness within 30
      days of purchase by completing this
      <SkyLink
        inline
        to="https://community.grove.co/hc/en-us/requests/new"
        target="_blank"
        tag="a"
        >form</SkyLink
      >.
    </p>
  </section>
</template>

<style lang="scss">
.TheReturnPolicy {
  display: grid;
  row-gap: var(--spacing-3x);

  &_Heading {
    @include type-brand-heading('2');
    margin-top: var(--spacing-8x);
  }

  &_EffectiveDate {
    @include type-body('l', true);
    margin-bottom: var(--spacing-3x);
  }

  &_BulletPoints {
    margin: 0;
    display: grid;
    row-gap: var(--spacing-2x);
  }
}
</style>
